import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: () =>
    css({
      position: 'absolute',
      zIndex: 1501,
    }),
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
